import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

// Translation files
const resources = {
  en: {
    translation: {
      // Navigation
      nav: {
        home: "Home",
        about: "About",
        services: "Services",
        contact: "Contact"
      },
      // Home Page
      home: {
        heroTitle: "Building Excellence, Delivering Trust",
        heroSubtitle: "Your partner in residential, commercial and industrial construction projects across Quebec",
        ctaButton: "Get in Touch",
        servicesTitle: "Our Services",
        whyChooseTitle: "Why Choose Aegis Construction?",
        whyChooseSubtitle: "Experience, Quality, and Reliability",
        ctaTitle: "Ready to Start Your Project?",
        ctaSubtitle: "Let's discuss how we can bring your construction vision to life"
      },
      // Services
      services: {
        projectManagement: "Project Management",
        projectManagementDesc: "Comprehensive oversight from planning to completion",
        residential: "Multi-Residential",
        residentialDesc: "Custom homes and residential projects built to perfection",
        commercial: "Commercial",
        commercialDesc: "Professional commercial building solutions",
        renovations: "Industrial",
        renovationsDesc: "Transform your industrial space with expert construction"
      },
      // Why Choose Us
      whyChoose: {
        experience: "Experience",
        experienceDesc: "Years of expertise in residential and commercial construction",
        quality: "Quality",
        qualityDesc: "Commitment to excellence in every project we undertake",
        reliability: "Reliability",
        reliabilityDesc: "On-time delivery and transparent communication"
      },
      // About Page
      about: {
        title: "About Aegis Construction",
        subtitle: "Your Trusted Construction Partner",
        description: "With years of experience in the construction industry, Aegis Construction has built a reputation for excellence, reliability, and quality craftsmanship.",
        whoWeAre: "Who We Are",
        whoWeAreP1: "At Aegis Construction, we specialize in delivering comprehensive construction solutions for both residential and commercial projects. Our team of experienced professionals brings together expertise in project management, general contracting, and specialized construction services.",
        whoWeAreP2: "From initial planning to final completion, we ensure every phase of your project is executed with precision, professionalism, and care. Our commitment to quality and client satisfaction has made us a trusted partner for construction projects across Quebec.",
        coreValuesTitle: "Our Core Values",
        qualityCraftsmanship: "Quality Craftsmanship",
        qualityCraftsmanshipDesc: "We deliver exceptional quality in every project, ensuring attention to detail and superior workmanship.",
        clientFocused: "Client-Focused",
        clientFocusedDesc: "Your vision is our priority. We work closely with clients to exceed expectations and deliver results.",
        integrity: "Integrity",
        integrityDesc: "Honest communication, transparent pricing, and ethical business practices guide everything we do.",
        safetyFirst: "Safety First",
        safetyFirstDesc: "We maintain the highest safety standards on every job site to protect our team and clients.",
        statsYears: "Years of Experience",
        statsProjects: "Projects Completed",
        statsSatisfaction: "Client Satisfaction",
        statsTeam: "Team Members",
        ctaTitle: "Ready to Work With Us?",
        ctaSubtitle: "Let's build something amazing together",
        ctaButton: "Get in Touch"
      },
      // Services Page
      servicesPage: {
        title: "Our Services",
        subtitle: "Comprehensive construction solutions tailored to your needs",
        pmFeature1: "Budget planning and cost control",
        pmFeature2: "Timeline management",
        pmFeature3: "Quality assurance",
        pmFeature4: "Subcontractor coordination",
        pmFeature5: "Regular progress reporting",
        resFeature1: "Custom home construction",
        resFeature2: "New home builds",
        resFeature3: "Home additions",
        resFeature4: "Residential renovations",
        resFeature5: "Interior and exterior work",
        comFeature1: "Office buildings",
        comFeature2: "Retail spaces",
        comFeature3: "Industrial facilities",
        comFeature4: "Multi-unit developments",
        comFeature5: "Tenant improvements",
        renFeature1: "Kitchen and bathroom remodels",
        renFeature2: "Basement finishing",
        renFeature3: "Interior upgrades",
        renFeature4: "Exterior renovations",
        renFeature5: "Structural modifications",
        processTitle: "Our Process",
        step1Title: "Consultation",
        step1Desc: "We meet to discuss your vision, requirements, and budget",
        step2Title: "Planning",
        step2Desc: "Detailed project planning, design, and timeline development",
        step3Title: "Execution",
        step3Desc: "Professional construction with quality control at every stage",
        step4Title: "Completion",
        step4Desc: "Final inspection, walkthrough, and project handover",
        ctaTitle: "Start Your Project Today",
        ctaSubtitle: "Ready to bring your construction project to life? Let's talk!"
      },
      // Contact Page
      contact: {
        title: "Contact",
        subtitle: "Get in touch with us to discuss your project",
        conversationTitle: "Let's Start a Conversation",
        conversationText: "Ready to bring your construction project to life? We'd love to hear from you. Schedule a consultation with our team to discuss your vision and how we can help make it a reality.",
        phone: "Phone",
        phoneHours: "Monday - Friday, 8:00 AM - 5:00 PM",
        email: "Email",
        emailNote: "We'll respond within 24 hours",
        location: "Location",
        locationNote: "Serving the Greater Montreal Area",
        bookingTitle: "Book a Consultation",
        bookingText: "Schedule a meeting with our team to discuss your construction project. We'll review your requirements, timeline, and budget to create a customized solution.",
        benefit1: "Free initial consultation",
        benefit2: "Project assessment and planning",
        benefit3: "Budget estimation",
        benefit4: "Timeline discussion",
        bookingButton: "Contact Us",
        mapTitle: "Serving Montreal & Surrounding Areas",
        mapSubtitle: "Quality construction services throughout Quebec",
        followUs: "Follow Us"
      },
      // Footer
      footer: {
        rights: "All rights reserved.",
        contact: "Contact Us"
      }
    }
  },
  fr: {
    translation: {
      // Navigation
      nav: {
        home: "Accueil",
        about: "À Propos",
        services: "Services",
        contact: "Contact"
      },
      // Home Page
      home: {
        heroTitle: "Construire l'Excellence, Livrer la Confiance",
        heroSubtitle: "Votre partenaire pour les projets de construction résidentielle, commerciale et industrielle au Québec",
        ctaButton: "Nous Contacter",
        servicesTitle: "Nos Services",
        whyChooseTitle: "Pourquoi Choisir Aegis Construction?",
        whyChooseSubtitle: "Expérience, Qualité et Fiabilité",
        ctaTitle: "Prêt à Démarrer Votre Projet?",
        ctaSubtitle: "Discutons de la façon dont nous pouvons donner vie à votre vision de construction"
      },
      // Services
      services: {
        projectManagement: "Gestion de Projet",
        projectManagementDesc: "Supervision complète de la planification à l'achèvement",
        residential: "Multi-Résidentielle",
        residentialDesc: "Maisons sur mesure et projets résidentiels construits à la perfection",
        commercial: "Commerciale",
        commercialDesc: "Solutions de construction commerciale professionnelles",
        renovations: "Industriel",
        renovationsDesc: "Transformez votre espace industriel avec une construction experte"
      },
      // Why Choose Us
      whyChoose: {
        experience: "Expérience",
        experienceDesc: "Des années d'expertise en construction résidentielle et commerciale",
        quality: "Qualité",
        qualityDesc: "Engagement envers l'excellence dans chaque projet que nous entreprenons",
        reliability: "Fiabilité",
        reliabilityDesc: "Livraison à temps et communication transparente"
      },
      // About Page
      about: {
        title: "À Propos d'Aegis Construction",
        subtitle: "Votre Partenaire de Construction de Confiance",
        description: "Avec des années d'expérience dans l'industrie de la construction, Aegis Construction s'est bâti une réputation d'excellence, de fiabilité et de qualité d'exécution.",
        whoWeAre: "Qui Nous Sommes",
        whoWeAreP1: "Chez Aegis Construction, nous nous spécialisons dans la prestation de solutions de construction complètes pour les projets résidentiels et commerciaux. Notre équipe de professionnels expérimentés réunit une expertise en gestion de projet, en entreprise générale et en services de construction spécialisés.",
        whoWeAreP2: "De la planification initiale à l'achèvement final, nous nous assurons que chaque phase de votre projet est exécutée avec précision, professionnalisme et soin. Notre engagement envers la qualité et la satisfaction du client a fait de nous un partenaire de confiance pour les projets de construction à travers le Québec.",
        coreValuesTitle: "Nos Valeurs Fondamentales",
        qualityCraftsmanship: "Artisanat de Qualité",
        qualityCraftsmanshipDesc: "Nous offrons une qualité exceptionnelle dans chaque projet, en garantissant l'attention aux détails et un travail supérieur.",
        clientFocused: "Axé sur le Client",
        clientFocusedDesc: "Votre vision est notre priorité. Nous travaillons en étroite collaboration avec les clients pour dépasser les attentes et livrer des résultats.",
        integrity: "Intégrité",
        integrityDesc: "Une communication honnête, une tarification transparente et des pratiques commerciales éthiques guident tout ce que nous faisons.",
        safetyFirst: "Sécurité Avant Tout",
        safetyFirstDesc: "Nous maintenons les normes de sécurité les plus élevées sur chaque chantier pour protéger notre équipe et nos clients.",
        statsYears: "Années d'Expérience",
        statsProjects: "Projets Réalisés",
        statsSatisfaction: "Satisfaction Client",
        statsTeam: "Membres de l'Équipe",
        ctaTitle: "Prêt à Travailler Avec Nous?",
        ctaSubtitle: "Construisons quelque chose d'incroyable ensemble",
        ctaButton: "Nous Contacter"
      },
      // Services Page
      servicesPage: {
        title: "Nos Services",
        subtitle: "Solutions de construction complètes adaptées à vos besoins",
        pmFeature1: "Planification budgétaire et contrôle des coûts",
        pmFeature2: "Gestion du calendrier",
        pmFeature3: "Assurance qualité",
        pmFeature4: "Coordination des sous-traitants",
        pmFeature5: "Rapports d'avancement réguliers",
        resFeature1: "Construction de maisons sur mesure",
        resFeature2: "Construction de nouvelles maisons",
        resFeature3: "Ajouts de maison",
        resFeature4: "Rénovations résidentielles",
        resFeature5: "Travaux intérieurs et extérieurs",
        comFeature1: "Immeubles de bureaux",
        comFeature2: "Espaces de vente au détail",
        comFeature3: "Installations industrielles",
        comFeature4: "Développements multi-unités",
        comFeature5: "Améliorations locatives",
        renFeature1: "Rénovations de cuisine et salle de bain",
        renFeature2: "Finition de sous-sol",
        renFeature3: "Améliorations intérieures",
        renFeature4: "Rénovations extérieures",
        renFeature5: "Modifications structurelles",
        processTitle: "Notre Processus",
        step1Title: "Consultation",
        step1Desc: "Nous nous rencontrons pour discuter de votre vision, de vos exigences et de votre budget",
        step2Title: "Planification",
        step2Desc: "Planification détaillée du projet, conception et développement du calendrier",
        step3Title: "Exécution",
        step3Desc: "Construction professionnelle avec contrôle de qualité à chaque étape",
        step4Title: "Achèvement",
        step4Desc: "Inspection finale, visite guidée et remise du projet",
        ctaTitle: "Commencez Votre Projet Aujourd'hui",
        ctaSubtitle: "Prêt à donner vie à votre projet de construction? Parlons-en!"
      },
      // Contact Page
      contact: {
        title: "Contact",
        subtitle: "Contactez-nous pour discuter de votre projet",
        conversationTitle: "Commençons une Conversation",
        conversationText: "Prêt à donner vie à votre projet de construction? Nous aimerions avoir de vos nouvelles. Planifiez une consultation avec notre équipe pour discuter de votre vision et de la façon dont nous pouvons vous aider à la réaliser.",
        phone: "Téléphone",
        phoneHours: "Lundi - Vendredi, 8h00 - 17h00",
        email: "Courriel",
        emailNote: "Nous répondrons dans les 24 heures",
        location: "Emplacement",
        locationNote: "Desservant la Région du Grand Montréal",
        bookingTitle: "Réserver une Consultation",
        bookingText: "Planifiez une rencontre avec notre équipe pour discuter de votre projet de construction. Nous examinerons vos exigences, votre calendrier et votre budget pour créer une solution personnalisée.",
        benefit1: "Consultation initiale gratuite",
        benefit2: "Évaluation et planification du projet",
        benefit3: "Estimation du budget",
        benefit4: "Discussion du calendrier",
        bookingButton: "Contactez-nous",
        mapTitle: "Desservant Montréal et Environs",
        mapSubtitle: "Services de construction de qualité partout au Québec",
        followUs: "Suivez-Nous"
      },
      // Footer
      footer: {
        rights: "Tous droits réservés.",
        contact: "Contactez-Nous"
      }
    }
  }
};

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: 'en', // default language
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false
    }
  });

export default i18n;